/**
 * @generated SignedSource<<cb64252ff329567d2c5d3357e48f9e3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stakeholderDetailPage_Query$variables = {
  from?: string | null | undefined;
  month?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  stakeholderId: string;
};
export type stakeholderDetailPage_Query$data = {
  readonly categories: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly parent: {
      readonly id: string;
    } | null | undefined;
  }>;
  readonly stakeholderDetail: {
    readonly category: string | null | undefined;
    readonly monthly: ReadonlyArray<{
      readonly cashIn: number;
      readonly cashOut: number;
      readonly month: string;
    }>;
    readonly path: ReadonlyArray<string>;
    readonly rules: ReadonlyArray<{
      readonly direction: string;
      readonly id: string;
      readonly regex: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly morphSteps: ReadonlyArray<{
        readonly delta: number;
        readonly kind: string;
        readonly label: string;
        readonly points: ReadonlyArray<{
          readonly month: string;
          readonly value: number | null | undefined;
        }>;
        readonly total: number;
      }>;
      readonly name: string;
      readonly transformChain: {
        readonly enabled: boolean;
        readonly steps: ReadonlyArray<{
          readonly anchorJson: string | null | undefined;
          readonly kind: string;
          readonly ordinal: number;
          readonly paramsJson: string;
        }>;
      };
    };
  };
  readonly transformCatalog: ReadonlyArray<{
    readonly conservesExactly: boolean;
    readonly kind: string;
    readonly paramsSchemaJson: string;
  }>;
};
export type stakeholderDetailPage_Query = {
  response: stakeholderDetailPage_Query$data;
  variables: stakeholderDetailPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stakeholderId"
},
v4 = {
  "kind": "Variable",
  "name": "perspectiveId",
  "variableName": "perspectiveId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "stakeholderId",
    "variableName": "stakeholderId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delta",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paramsJson",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorJson",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rules",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "regex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "direction",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cashIn",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cashOut",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": [
    (v4/*: any*/)
  ],
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "categories",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Category",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": [
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paramsSchemaJson",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conservesExactly",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderDetailPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "StakeholderDetail",
        "kind": "LinkedField",
        "name": "stakeholderDetail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MorphStep",
                "kind": "LinkedField",
                "name": "morphSteps",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricPoint",
                    "kind": "LinkedField",
                    "name": "points",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TransformChain",
                "kind": "LinkedField",
                "name": "transformChain",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransformStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v8/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountMonth",
            "kind": "LinkedField",
            "name": "monthly",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v23/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TransformCatalogEntry",
        "kind": "LinkedField",
        "name": "transformCatalog",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "stakeholderDetailPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "StakeholderDetail",
        "kind": "LinkedField",
        "name": "stakeholderDetail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholder",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MorphStep",
                "kind": "LinkedField",
                "name": "morphSteps",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetricPoint",
                    "kind": "LinkedField",
                    "name": "points",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TransformChain",
                "kind": "LinkedField",
                "name": "transformChain",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransformStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v8/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountMonth",
            "kind": "LinkedField",
            "name": "monthly",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      (v23/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TransformCatalogEntry",
        "kind": "LinkedField",
        "name": "transformCatalog",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2e2a07b234bb6a78bdd4d8091bfe44fb",
    "id": null,
    "metadata": {},
    "name": "stakeholderDetailPage_Query",
    "operationKind": "query",
    "text": "query stakeholderDetailPage_Query(\n  $stakeholderId: ID!\n  $month: String\n  $perspectiveId: ID\n  $from: String\n) {\n  stakeholderDetail(stakeholderId: $stakeholderId, month: $month, perspectiveId: $perspectiveId, from: $from) {\n    stakeholder {\n      id\n      name\n      morphSteps {\n        kind\n        label\n        total\n        delta\n        points {\n          month\n          value\n          id\n        }\n        id\n      }\n      transformChain {\n        enabled\n        steps {\n          ordinal\n          kind\n          paramsJson\n          anchorJson\n          id\n        }\n        id\n      }\n    }\n    path\n    category\n    rules {\n      id\n      regex\n      direction\n    }\n    monthly {\n      month\n      cashIn\n      cashOut\n      id\n    }\n    id\n  }\n  categories(perspectiveId: $perspectiveId) {\n    id\n    name\n    parent {\n      id\n    }\n  }\n  transformCatalog {\n    kind\n    paramsSchemaJson\n    conservesExactly\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "be5014a83ba47e8663ccf7b242c52416";

export default node;
